// DesktopNav.js
import React, { useState } from 'react';
import Logo from './Logo';
import { navItems } from './navItems';
import DataWellSVG from './DataWellSVG';  // Changed from { DataWellSVG }

const DesktopNav = ({ onNavigate, currentPath }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <aside
            className={`fixed left-0 top-0 h-screen bg-gradient-to-b from-[#cccccc] to-[#c4c4c4] 
                shadow-lg z-50 border-r border-blue-900 transition-all duration-300 
                ${isExpanded ? 'w-64' : 'w-16'}`}
            onMouseEnter={() => setIsExpanded(true)}
            onMouseLeave={() => setIsExpanded(false)}
        >
            <div className="flex flex-col h-full">
                <div className="flex items-center justify-center h-16 px-4 border-b border-blue-900 bg-white/10">
                    <Logo expanded={isExpanded} size="large" />
                </div>

                <nav className="flex-1 py-4">
                    {navItems.map((item) => (
                        <button
                            key={item.path}
                            onClick={() => onNavigate(item.path)}
                            className={`w-full flex items-center px-4 py-3 relative border-l-4
                                ${currentPath === item.path
                                    ? 'text-white bg-blue-900 border-white'
                                    : 'text-blue-900 hover:bg-white/50 border-transparent'}`}
                        >
                            <span className={currentPath === item.path ? 'text-white' : 'text-blue-900'}>
                                {item.icon}
                            </span>
                            <span className={`ml-3 whitespace-nowrap transition-opacity duration-300
                                ${isExpanded ? 'opacity-100' : 'opacity-0'}`}>
                                {item.label}
                            </span>
                        </button>
                    ))}
                </nav>

                <div className="mt-auto p-4">
                    <div className={`transition-opacity duration-300 ${isExpanded ? 'opacity-100' : 'opacity-0'}`}>
                        <div className="h-96 opacity-30 filter drop-shadow">
                            <DataWellSVG />
                        </div>
                        <p className="text-sm text-blue-900 text-center font-medium">
                            Powered by DataOil
                        </p>
                    </div>
                </div>
            </div>
        </aside>
    );
};

export default DesktopNav;